const T = 5e3, E = 3e4, o = "FR-SDK";
export {
  E as DEFAULT_OAUTH_THRESHOLD,
  T as DEFAULT_TIMEOUT,
  o as PREFIX
};
